// extracted by mini-css-extract-plugin
module.exports = {"content":"_0cbaba7d8a--content--n4_do","text":"_0cbaba7d8a--text--Pgt0n","ok":"_0cbaba7d8a--ok--fHZtg"};